import { Box } from "@chakra-ui/react";
import Marquee from "./Marquee";

function NavbarContact() {
  return (
    <Box>
      <Marquee />
    </Box>
  );
}

export default NavbarContact;
